import { render } from "./B2BMembersInvitation.vue?vue&type=template&id=2c1a0052&scoped=true"
import script from "./B2BMembersInvitation.vue?vue&type=script&lang=js"
export * from "./B2BMembersInvitation.vue?vue&type=script&lang=js"

import "./B2BMembersInvitation.vue?vue&type=style&index=0&id=2c1a0052&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1a0052"]])

export default __exports__